import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ServicesPage from "@/pages/services/page";
import ServiceDetailPage from "@/pages/services/detail/page";
import AboutPage from "@/pages/about/page";
import ServiceAreasPage from "@/pages/service-areas/page";
import BookPage from "@/pages/book/page";
import TechniciansPage from "@/pages/technicians/page";
import TechnicianDetailPage from "@/pages/technicians/detail/page";
import PricingPage from "@/pages/pricing/page";
import ReviewsPage from "@/pages/reviews/page";

// Public website only. Legacy /staff/*, /account/* and /appointment* workspaces are no longer
// registered (source kept until F03 cleanup) and fall through to the normal 404 page.
export const pageRoutes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/services/:slug", element: <ServiceDetailPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/service-areas", element: <ServiceAreasPage /> },
  { path: "/book", element: <BookPage /> },
  { path: "/technicians", element: <TechniciansPage /> },
  { path: "/technicians/:slug", element: <TechnicianDetailPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "*", element: <NotFound /> },
];